//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import SearchBox from '~/components/SearchBox';
import LoadingData from '~/components/LoadingData';
//import WhoView from '~/components/loading/WhoView'
//import WhoViewReport from '~/components/loading/WhoViewReport'
//import LoadingSvg from '~/components/loading/LoadingSvg'
//import ProgressBar from 'vue-simple-progress'
export default {
    layout: function layout(context) {
        return global.getTheme();
    },

    components: {
        SearchBox: SearchBox, LoadingData: LoadingData /*, ProgressBar,WhoView,WhoViewReport,LoadingSvg*/
    },
    data: function data() {
        return {
            loading: false,
            searchText: '',
            type: 'name',
            websiteLogo: '',
            increasing_pct: 0,
            loadingStep: false,
            step1: {
                whoView: true,
                whoViewReport: false
            }
        };
    },
    created: function created() {
        this.websiteLogo = global.websiteSettings.extra_info.api_endpoint + global.websiteSettings.extra_info.logo_file;
    },
    mounted: function mounted() {
        var _this = this;

        setInterval(function () {
            if (_this.increasing_pct == 33) _this.activateCurrentStep(1);
            if (_this.increasing_pct == 66) _this.activateCurrentStep(2);
            if (_this.increasing_pct == 100) _this.activateCurrentStep(3);
            _this.increasing_pct = Math.min(_this.increasing_pct + 1, 100);
        }, 1000);
    },

    computed: {
        lang: function lang() {
            return this.$root._route.params.lang;
        },

        websiteName: function websiteName() {
            var displayName = global.websiteSettings.extra_info.display_name;
            if (displayName) {
                return this.$root.trans('st_public.' + displayName);
            }
            return '';
        }
    },
    methods: {
        whoViewListener: function whoViewListener(value) {
            var _this2 = this;

            if (value == 100 && this.step1.whoView) {
                setInterval(function () {
                    _this2.step1.whoView = false;
                    _this2.loadingStep = true;
                    setInterval(function () {
                        _this2.loadingStep = false;
                        _this2.step1.whoViewReport = true;
                    }, 1000);
                }, 1000);
            }
        },
        activateCurrentStep: function activateCurrentStep(step) {
            document.getElementById('step' + step).classList.remove('active');
            document.getElementById('step' + step).classList.add('done');
            step = step + 1;
            document.getElementById('step' + step).classList.add('active');
        },
        startLoading: function startLoading(flag, searchText) {
            this.loading = flag;
            this.searchText = searchText;
        },
        stopLoading: function stopLoading(flag) {
            this.loading = flag;
        },
        hardCodedBG: function hardCodedBG() {
            if (process.client) {
                if (window.location.hostname.match(/hawiyyah/i)) {
                    return true;
                }
            }
            return false;
        }
    }
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/babel-loader/lib?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/new-loading.vue
// module id = ./node_modules/babel-loader/lib/index.js?{"babelrc":false,"cacheDirectory":true,"presets":[["/var/www/html/node_modules/babel-preset-vue-app/dist/index.common.js",{"targets":{"ie":9,"uglify":true}}]]}!./node_modules/vue-loader/lib/selector.js?type=script&index=0!./pages/_lang/new-loading.vue
// module chunks = 7